import apiClient from './api';

export const getWorkerById = async (id) => {
  try {
    const response = await apiClient.get(`/workers/${id}`);
    return response.data;
  } catch (error) {
    throw error;
  }
};
